import { NavItem, NewsItem, CoreValue, JoinStep } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const navItems: NavItem[] = [
  { label: '關於我們', href: '#about' },
  { label: '最新動向', href: '#news' },
  { label: '聯絡我們', href: '#contact' }
];

export const newsItems: NewsItem[] = [
  {
    id: '1',
    title: '香港中醫藥發展基金正式啟動',
    date: '2026-03-15',
    category: '行業動態',
    excerpt: '政府宣布撥款5億港元成立中醫藥發展基金，支持中醫師專業培訓及臨床研究項目，推動香港中醫藥現代化發展。',
    image: IMAGES.TCM_HERBS_4
  },
  {
    id: '2',
    title: '工會成功爭取中醫師薪酬調整方案',
    date: '2026-02-28',
    category: '會員權益',
    excerpt: '經過多月協商，工會成功與醫管局達成共識，中醫師薪酬將按資歷及專業資格調整，預計惠及全港超過800名公營中醫師。',
    image: IMAGES.TCM_HERO_10
  },
  {
    id: '3',
    title: '2026年中醫藥國際研討會圓滿舉行',
    date: '2026-01-20',
    category: '專業發展',
    excerpt: '本會協辦的中醫藥國際研討會吸引來自15個國家的專家學者參與，探討中西醫結合治療的最新進展及臨床應用。',
    image: IMAGES.HK_CITY_1
  },
  {
    id: '4',
    title: '新增會員福利：專業責任保險計劃',
    date: '2025-12-10',
    category: '會員服務',
    excerpt: '工會與保險公司合作推出專業責任保險計劃，為會員提供全面保障，保費優惠高達30%，保障額最高達500萬港元。',
    image: IMAGES.TCM_DOCTOR_8
  }
];

export const coreValues: CoreValue[] = [
  {
    id: '1',
    icon: 'Award',
    title: '專業至上',
    description: '堅持中醫藥的專業標準，維護行業專業操守，推動中醫師持續進修及專業發展，確保為市民提供優質中醫藥服務。'
  },
  {
    id: '2',
    icon: 'Users',
    title: '團結互助',
    description: '凝聚中醫師力量，建立互助網絡，促進業界交流合作，共同應對行業挑戰，為會員提供全方位支援。'
  },
  {
    id: '3',
    icon: 'Scale',
    title: '廉潔公正',
    description: '秉持公平公正原則，維護會員合法權益，以透明誠信的態度處理工會事務，建立良好的行業形象。'
  },
  {
    id: '4',
    icon: 'Heart',
    title: '服務會員',
    description: '以會員需求為本，提供專業諮詢、法律支援、培訓進修等全面服務，致力提升會員的職業發展及生活質素。'
  }
];

export const joinSteps: JoinStep[] = [
  {
    id: '1',
    step: 1,
    title: '下載並填寫申請表',
    description: '請下載「正式會員申請表」(HKCMPRGU)，填妥後備用。'
  },
  {
    id: '2',
    step: 2,
    title: '準備證明文件',
    description: '提供香港中醫師執業證明書副本及身份證副本。'
  },
  {
    id: '3',
    step: 3,
    title: '繳交會費',
    description: '繳交會費港幣 $100。'
  },
  {
    id: '4',
    step: 4,
    title: '提交資料及等候審核',
    description: '將以上三項資料（申請表、證明文件、付款證明）WhatsApp 或電郵至本會。審核通過後，將於 14 個工作天內發出會員證。'
  }
];

export const statsData = [
  { label: '註冊會員', value: '350+', icon: 'Users' },
  { label: '已服務', value: '23年', icon: 'Calendar' },
  { label: '服務會員', value: '誠心盡力', icon: 'Shield' }
];

export const officeHours = [
  { day: '星期一至五', time: '09:00 - 18:00' },
  { day: '星期六', time: '09:00 - 13:00' },
  { day: '星期日及公眾假期', time: '休息' }
];